// extracted by mini-css-extract-plugin
module.exports = {"body":"ScheduledBranchCall_body__10G9y","option":"ScheduledBranchCall_option__3ltqH"};